module.exports = __webpack_public_path__ + "static/dex-screener-61646fb0a752c1734ca98fd1a9e1e1c8.png";